// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
#exportedSVG {
  background-color: #0d1824;
  padding: 2em;
}

.blocklyEditableText text.blocklyText {
  fill: #575E75 !important;
}

.blocklyEditableText text.blocklyDropdownText {
  fill: #FFF !important;
}

.direction-ltr {
  direction: ltr;
}

.box-shadow-none {
  box-shadow: none;
}

.blocklyWidgetDiv {
  max-width: 100vw;
  max-height: calc(100vh - 25px);
}
.blocklyWidgetDiv .popup-modal-under {
  background: #0000006e;
  width: 100vw;
  height: 100vh;
}
.blocklyWidgetDiv .popup-modal-close {
  width: 20px;
  height: 20px;
  color: white;
  opacity: 0;
  position: absolute;
  margin: auto;
  z-index: 1;
  text-align: center;
  cursor: pointer;
  font-size: 0.8rem;
  animation: 0.4s rotate-and-translate cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation-delay: 0.2s;
  transition: 0.2s all ease;
}
.blocklyWidgetDiv .popup-modal-close:hover {
  opacity: 1 !important;
}
.blocklyWidgetDiv .initial-popup {
  animation: scale-up-center 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
.blocklyWidgetDiv .popup-hide {
  animation: scale-down-center 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.matrix-mini-modal {
  width: 54px;
  height: 54px;
  background-color: transparent;
  border: 0px solid #252f41;
  border-radius: 5%;
  margin-top: 26px;
  margin-left: 20px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.matrix-mini-modal.matrix-mini-modal-8 {
  padding: 0;
  margin-left: 7px;
  margin-top: 28px;
  height: 144px;
  width: 94px;
  background-image: url("/images/blocks/educablocks/matrix.svg");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  transform: scale(0.9);
}
.matrix-mini-modal.matrix-mini-modal-8 .mini-modal-leds-container {
  transform: rotate(-90deg) translate(6px, -5px);
  margin-top: 25px;
  margin-left: 10px;
  height: 75px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
}
.matrix-mini-modal.matrix-mini-modal-8 .mini-modal-leds-container .led-row {
  width: 75px;
  justify-content: space-around;
  align-items: center;
}
.matrix-mini-modal.matrix-mini-modal-8 .mini-modal-leds-container .led-row div.led {
  width: 7px;
  height: 7px;
}
.matrix-mini-modal.matrix-mini-modal-8 .mini-modal-leds-container .led-row div.led.led-on {
  background-color: #ff3636 !important;
}
.matrix-mini-modal.matrix-mini-modal-lgo-8 {
  padding: 0;
  margin-left: 7px;
  margin-top: 28px;
  height: 144px;
  width: 94px;
  background-image: url("/images/blocks/educablocks/matrix.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  transform: scale(0.9);
}
.matrix-mini-modal.matrix-mini-modal-lgo-8 .mini-modal-leds-container {
  transform: rotate(-90deg) translate(6px, -5px);
  margin-top: 15px;
  margin-left: 10px;
  height: 75px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
}
.matrix-mini-modal.matrix-mini-modal-lgo-8 .mini-modal-leds-container .led-row {
  width: 75px;
  justify-content: space-around;
  align-items: center;
}
.matrix-mini-modal.matrix-mini-modal-lgo-8 .mini-modal-leds-container .led-row div.led {
  width: 5px;
  height: 5px;
}
.matrix-mini-modal.matrix-mini-modal-lgo-8 .mini-modal-leds-container .led-row div.led.led-on {
  background-color: #3090ef !important;
}
.matrix-mini-modal div.led-row {
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-direction: row;
}
.matrix-mini-modal div.led {
  transition: 0.2s all ease-in-out;
  width: 5px;
  height: 5px;
  background: #A7A9AC;
  border-radius: 50%;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.matrix-mini-modal div.led.led-on {
  background-color: #db0a5b;
}

.matrix-mini-modal-horizontal {
  width: 165px;
  height: 54px;
  background-color: transparent;
  border: 0px solid #252f41;
  border-radius: 5%;
  margin-top: 45px;
  margin-left: 20px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-16 {
  padding: 0;
  margin-left: 8px;
  height: 165px;
  width: 175px;
  background-image: url("/images/blocks/Bhoot/14.svg");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-16 .mini-modal-leds-container {
  margin-top: 40px;
  margin-left: 13px;
  height: 75px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-16 .mini-modal-leds-container .led-row {
  width: 149px;
  justify-content: space-around;
  align-items: center;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-16 .mini-modal-leds-container .led-row div.led {
  width: 4px;
  height: 4px;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-16 .mini-modal-leds-container .led-row div.led.led-on {
  background-color: #0f6efb !important;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-junior-16 {
  padding: 0;
  margin-top: 3px;
  margin-left: 0.6rem;
  width: 3.3rem;
  display: flex;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-junior-16 .mini-modal-leds-container {
  margin: 0;
  height: 38px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
  background-color: #464646;
  padding: 0.19rem 0.16rem;
  border-radius: 4px;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-junior-16 .mini-modal-leds-container .led-row {
  width: 100%;
  justify-content: space-around;
  align-items: center;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-junior-16 .mini-modal-leds-container .led-row div.led {
  width: 3px;
  height: 3px;
  background-color: #FFFFFF;
}
.matrix-mini-modal-horizontal.matrix-mini-modal-junior-16 .mini-modal-leds-container .led-row div.led.led-on {
  background-color: #0f6efb !important;
}
.matrix-mini-modal-horizontal div.led-row {
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-direction: row;
}
.matrix-mini-modal-horizontal div.led {
  transition: 0.2s all ease-in-out;
  width: 5px;
  height: 5px;
  background: #A7A9AC;
  border-radius: 50%;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.matrix-mini-modal-horizontal div.led.led-on {
  background-color: #db0a5b;
}

.oled-mini-modal {
  width: 165px;
  height: 54px;
  background-color: transparent;
  border: 0px solid #252f41;
  border-radius: 5%;
  margin-top: 45px;
  margin-left: 20px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.oled-mini-modal.oled-mini-modal-16 {
  padding: 0;
  margin-left: 8px;
  height: 165px;
  width: 175px;
  background-image: url("/images/blocks/educablocks/oled.svg");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
}
.oled-mini-modal.oled-mini-modal-16 .mini-modal-leds-container {
  margin-top: 45px;
  margin-left: 20px;
  height: 60px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
}
.oled-mini-modal.oled-mini-modal-16 .mini-modal-leds-container .led-row {
  width: 130px;
  justify-content: space-around;
  align-items: center;
}
.oled-mini-modal.oled-mini-modal-16 .mini-modal-leds-container .led-row div.led {
  width: 6px;
  height: 6px;
}
.oled-mini-modal.oled-mini-modal-16 .mini-modal-leds-container .led-row div.led.led-on {
  background-color: #86b6ff !important;
}
.oled-mini-modal div.led-row {
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-direction: row;
}
.oled-mini-modal div.led {
  transition: 0.2s all ease-in-out;
  width: 6px;
  height: 6px;
  background: #000000;
  border-radius: 50%;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.oled-mini-modal div.led.led-on {
  background-color: #86b6ff;
}
.oled-mini-modal div.led.opacity25 {
  opacity: 0.25;
}
.oled-mini-modal div.led.opacity50 {
  opacity: 0.5;
}
.oled-mini-modal div.led.opacity75 {
  opacity: 0.75;
}
.oled-mini-modal div.led.opacity100 {
  opacity: 1;
}

.oled-modal-parent {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2;
}
.oled-modal-parent .oled-modal-under {
  bottom: 0px;
  top: 0px;
  position: absolute;
  left: 0px;
  right: 0px;
  margin: auto;
  padding: 10px;
  max-width: 44rem;
  max-height: 18.5rem;
  background-color: #2D2E38;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}
.oled-modal-parent .oled-modal-under .oled-frames {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row-reverse;
  border-radius: 5px;
  padding: 1rem;
  background-color: #364158;
  background-size: 100px;
  border: 1px solid #252f41;
  justify-content: space-around;
  transition: 0.3s all ease-in-out;
  position: relative;
  z-index: 5;
}
.oled-modal-parent .oled-modal-under .oled-frames .oled-frames-prev, .oled-modal-parent .oled-modal-under .oled-frames .oled-frames-next {
  padding: 0;
  height: auto;
  min-width: 20px;
  width: 20px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.oled-modal-parent .oled-modal-under .oled-frames .oled-frames-prev.disabled, .oled-modal-parent .oled-modal-under .oled-frames .oled-frames-next.disabled {
  visibility: hidden;
}
.oled-modal-parent .oled-modal-under .oled-frames .oled-frames-prev {
  background-image: url("/images/blocks/educablocks/oled/oled_frame_prev.svg");
}
.oled-modal-parent .oled-modal-under .oled-frames .oled-frames-next {
  background-image: url("/images/blocks/educablocks/oled/oled_frame_next.svg");
}
.oled-modal-parent .oled-modal-under .oled-frames .oled-frames-duration {
  background-image: url("/images/blocks/educablocks/oled/oled_frame_separator.svg");
  background-size: 40px;
  background-position: 50% 35%;
  background-repeat: no-repeat;
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: #F1F1F1;
}
.oled-modal-parent .oled-modal-under .oled-frames .oled-frames-duration input {
  background-color: #D7D7D7;
  border: #EBAF15 3px solid;
  border-radius: 10px;
  color: #575E75;
  text-align: center;
  font-size: 1.2em;
  font-weight: bold;
  margin-top: 5px;
}
.oled-modal-parent .oled-modal-under .oled-carousel {
  max-width: 38rem;
  overflow-x: hidden;
  margin: 0 18px;
}
.oled-modal-parent .oled-modal-under .oled-carousel-modals {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row-reverse;
  justify-content: space-around;
  transition: transform 0.5s ease-in-out;
  padding: 10px 0;
}
.oled-modal-parent .oled-modal-under .oled-modal {
  background-color: #191919;
  border-radius: 10px;
  min-width: 220px;
  padding: 10px;
  margin: 0 20px;
}
.oled-modal-parent .oled-modal-under .oled-modal.selected {
  box-shadow: 0 1px 9px 3px #dada4c;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-frame-add {
  background-image: url("/images/blocks/educablocks/oled/oled_frame_add.svg");
  background-size: 30px;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #586280;
  cursor: pointer;
}
.oled-modal-parent .oled-modal-under .oled-modal .oled-modal-frame-title {
  margin-top: 10px;
  width: 100%;
  height: 20px;
  text-align: center;
  color: #F1F1F1;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
}
.oled-modal-parent .oled-modal-under .oled-modal .oled-modal-frame-maximize {
  margin-bottom: 5px;
  width: 15px;
  height: 15px;
  background-image: url("/images/blocks/educablocks/oled/oled_frame_maximize.svg");
  background-size: 15px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.oled-modal-parent .oled-modal-under .oled-modal .oled-modal-frame-delete {
  margin-left: 10px;
  width: 15px;
  height: 20px;
  background-image: url("/images/blocks/educablocks/oled/oled_frame_delete.svg");
  background-size: 15px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.oled-modal-parent .oled-modal-under .oled-modal div.led-row {
  display: flex;
  justify-content: space-around;
  flex-direction: row-reverse;
  position: relative;
  width: 100%;
  transition: 0.2s all ease-in-out;
}
.oled-modal-parent .oled-modal-under .oled-modal div.led-row::before {
  transition: inherit;
  content: attr(data-content);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999999;
}
.oled-modal-parent .oled-modal-under .oled-modal div.led-row:first-child div.led::before {
  content: attr(data-content);
  font-size: 0.8rem;
  position: absolute;
  top: -40px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999999;
}
.oled-modal-parent .oled-modal-under .oled-modal div.led {
  border-radius: 2px !important;
  margin: 0 2px 2px 0;
  width: 5px;
  height: 5px;
  background: #000000;
  border-radius: 50%;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
}
.oled-modal-parent .oled-modal-under .oled-modal div.led.led-on {
  background-color: #86b6ff;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-modal-16 {
  max-width: 20rem !important;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-modal-16 div.led-row:not([data-content=""])::before {
  top: 3px;
  left: -15px !important;
  height: initial;
  font-size: 0.7rem;
  color: #999999;
  border-top: 1px solid #999999;
  width: 14px;
  justify-content: right;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-modal-16 div.led-row:first-child div.led:not([data-content=""])::before {
  border-left: 1px solid #999999;
  padding-left: 2px;
  height: 12px;
  justify-content: left;
  top: -13px;
  font-size: 0.7rem;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-modal-16 div.led-row div.led.led-on {
  background-color: #86b6ff;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-modal-16 div.led-row div.led.opacity25 {
  opacity: 0.25;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-modal-16 div.led-row div.led.opacity50 {
  opacity: 0.5;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-modal-16 div.led-row div.led.opacity75 {
  opacity: 0.75;
}
.oled-modal-parent .oled-modal-under .oled-modal.oled-modal-16 div.led-row div.led.opacity100 {
  opacity: 1;
}
.oled-modal-parent .oled-modal-under .icon-modal-16 {
  width: 365px !important;
  height: 160px;
  left: 0;
  right: 0px;
}
.oled-modal-parent .oled-modal-under .modal-sidebar {
  width: 280px;
  height: 160px;
  color: white;
  bottom: 0px;
  top: 10px;
  position: absolute;
  left: 0;
  right: 0px;
  margin: auto;
  z-index: 1;
  text-align: center;
  font-size: 1rem;
  transition-delay: 0.2s;
  transition: 0.3s all ease-in-out;
}
.oled-modal-parent .oled-modal-under .modal-sidebar.start {
  top: 165px;
}
.oled-modal-parent .oled-modal-under .modal-sidebar.start .modal-sidebar-buttons {
  opacity: 1 !important;
}
.oled-modal-parent .oled-modal-under .modal-sidebar.open {
  top: 325px;
}
.oled-modal-parent .oled-modal-under .modal-sidebar.open .modal-sidebar-main-panel {
  opacity: 1 !important;
}
.oled-modal-parent .oled-modal-under .modal-sidebar.transitioning {
  top: 10px;
}
.oled-modal-parent .oled-modal-under .modal-sidebar.transitioning .modal-sidebar-main-panel {
  opacity: 0 !important;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel {
  overflow: hidden;
  transition: 0.5s all ease-in-out;
  display: inline-block;
  background: #082847;
  width: 280px;
  height: 90px;
  border-radius: 0.5%;
  padding: 1rem;
  opacity: 0;
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.15) inset;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 5px 10px;
  background-color: #334472;
  border-radius: 50%;
  border: 1px solid rgba(146, 146, 146, 0.027);
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle:hover {
  transform: scale(1.06);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-white {
  background-color: white;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-red {
  background-color: #cf000f;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-pink {
  background-color: #f62459;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-fuscia {
  background-color: #db0a5b;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-orange {
  background-color: orange;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-copper {
  background-color: #f22613;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-yellow {
  background-color: #f5e51b;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-gold {
  background-color: #f7ca18;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-blue {
  background-color: #2c82c9;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-dark-blue {
  background-color: #4d05e8;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-light-blue {
  background-color: #19b5fe;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-green {
  background-color: #2ecc71;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-dark-green {
  background-color: #1e824c;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-teal {
  background-color: teal;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller {
  direction: ltr;
  width: 85%;
  margin: 0 auto;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle {
  display: block;
  width: 100px;
  height: 50px;
  margin: 0 5px;
  background: #0f6efb;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle:hover {
  filter: none !important;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion1 {
  background: url("/images/blocks/educablocks/oled/cara1.png");
  background-size: contain;
  background-position: center;
  filter: grayscale(100%);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion2 {
  background: url("/images/blocks/educablocks/oled/cara2.png");
  background-size: contain;
  background-position: center;
  filter: grayscale(100%);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle {
  display: block;
  width: 100px;
  height: 50px;
  margin: 0 5px;
  background: #0f6efb;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle:hover {
  filter: none !important;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon1 {
  background: url("/images/blocks/educablocks/oled/arrow_up.png");
  background-size: contain;
  background-position: center;
  filter: grayscale(100%);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon2 {
  background: url("/images/blocks/educablocks/oled/arrow_down.png");
  background-size: contain;
  background-position: center;
  filter: grayscale(100%);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon3 {
  background: url("/images/blocks/educablocks/oled/arrow_left.png");
  background-size: contain;
  background-position: center;
  filter: grayscale(100%);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon4 {
  background: url("/images/blocks/educablocks/oled/arrow_right.png");
  background-size: contain;
  background-position: center;
  filter: grayscale(100%);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon5 {
  background: url("/images/blocks/educablocks/oled/icon_ok.png");
  background-size: contain;
  background-position: center;
  filter: grayscale(100%);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon6 {
  background: url("/images/blocks/educablocks/oled/icon_alert.png");
  background-size: contain;
  background-position: center;
  filter: grayscale(100%);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons {
  opacity: 0;
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
  height: auto;
  margin-top: 0.8rem;
  width: 100%;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  padding: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  border: 1px solid #ffffff9c;
  width: 1rem;
  height: 1rem;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker:hover, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button:hover {
  transform: scale(1.04);
  border-color: rgba(255, 255, 255, 0.815) !important;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.selected, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.selected {
  transform: scale(1.08);
  border-color: white !important;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.color-picker, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.color-picker {
  background-color: #db0a5b;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.emotions-picker, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.emotions-picker {
  background-image: url("/images/custom_blocks/matrix8x8/face_icon.png");
  background-position: center;
  background-size: 60%;
  background-repeat: no-repeat;
  background-color: #26A7FE;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.dice-picker, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.dice-picker {
  background-image: url("/images/custom_blocks/matrix8x8/dice_icon.png");
  background-position: center;
  background-size: 57%;
  background-repeat: no-repeat;
  background-color: #FF6427;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.icon-picker, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.icon-picker {
  background-image: url("/images/custom_blocks/matrix8x8/icon_icon.png");
  background-position: center;
  background-size: 59%;
  background-repeat: no-repeat;
  background-color: #FEB700;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.picker, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.picker {
  width: 2rem;
  height: 2rem;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.button, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.button {
  font-size: 1rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  border: 0;
  color: #f5f5f5;
  margin-top: 0.2rem;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.button:hover, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.button:hover {
  color: white;
  transform: scale(1.08);
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.button:active, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.button:active {
  color: grey;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.button.ruler-button, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.button.ruler-button {
  font-size: 1rem;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.button.rotate-button, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.button.rotate-button {
  font-size: 1rem;
}
.oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.picker.button.rotate-button:hover, .oled-modal-parent .oled-modal-under .modal-sidebar .modal-sidebar-buttons span.button.button.rotate-button:hover {
  animation: 0.8s full-rotation cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation-iteration-count: infinite;
  transform: scale(1.08);
  color: white;
}
.oled-modal-parent .oled-modal-under .icon-brush {
  width: 100px;
  height: 50px;
  color: white;
  bottom: 7px;
  position: absolute;
  left: 0;
  right: 150px;
  margin: auto 20px;
  z-index: 1;
  text-align: right;
  transition-delay: 0.2s;
  transition: 0.3s all ease-in-out;
  padding-top: 10px;
  display: flex;
}
.oled-modal-parent .oled-modal-under .icon-brush .brush-icon, .oled-modal-parent .oled-modal-under .icon-brush .erase-icon {
  width: 2rem;
  height: 2rem;
  margin-left: 10px;
  border-radius: 4px;
  border: solid 1px #ffffff5c;
  background-color: #5e5e5e80;
  cursor: pointer;
}
.oled-modal-parent .oled-modal-under .icon-brush .brush-icon.selected, .oled-modal-parent .oled-modal-under .icon-brush .erase-icon.selected {
  border: solid 2px #ffffffbf;
  background-color: #777777;
}
.oled-modal-parent .oled-modal-under .icon-brush .brush-icon {
  background-image: url("/images/blocks/educablocks/oled/oled_frame_pencil.svg");
  background-position: center;
  background-size: 59%;
  background-repeat: no-repeat;
}
.oled-modal-parent .oled-modal-under .icon-brush .erase-icon {
  background-image: url("/images/blocks/educablocks/oled/oled_frame_eraser.svg");
  background-position: center;
  background-size: 59%;
  background-repeat: no-repeat;
}
.oled-modal-parent .oled-modal-under .icon-slider {
  width: 130px;
  height: 50px;
  color: white;
  bottom: 10px;
  position: absolute;
  left: 0;
  right: 0px;
  margin: auto 20px;
  z-index: 1;
  text-align: center;
  transition-delay: 0.2s;
  transition: 0.3s all ease-in-out;
}
.oled-modal-parent .oled-modal-under .icon-slider .slider-container {
  width: 100%;
  margin: 20px 0;
}
.oled-modal-parent .oled-modal-under .icon-slider .slider {
  width: 100%;
  -webkit-appearance: none;
  appearance: none;
  height: 8px;
  background: #F1F1F1;
  border-radius: 3px;
  height: 6px;
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.oled-modal-parent .oled-modal-under .icon-slider .slider:hover {
  opacity: 1;
}
.oled-modal-parent .oled-modal-under .icon-slider .slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background: #F1F1F1;
  cursor: pointer;
  border-radius: 50%;
}
.oled-modal-parent .oled-modal-under .icon-slider .slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  background: #F1F1F1;
  cursor: pointer;
  border-radius: 50%;
}
.oled-modal-parent .oled-modal-under .icon-slider .slider-labels {
  padding: 3px 5px 5px 4px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: 2px;
  font: menu;
  font-size: 0.7rem;
}
.oled-modal-parent .oled-modal-under .icon-slider .slider-labels span {
  width: 10px;
  text-align: center;
}
.oled-modal-parent .oled-modal-under .oled-modal-close {
  bottom: 0px;
  top: -340px;
  position: absolute;
  left: 0px;
  right: 0px;
}
.oled-modal-parent .oled-modal-under-maximized {
  max-height: 34.5rem;
  max-width: 59.3rem;
  margin: 40px auto 0 auto;
}
.oled-modal-parent .oled-modal-under-maximized .oled-modal {
  min-width: 420px;
  margin: 0;
  padding: 0;
  border-radius: 0;
}
.oled-modal-parent .oled-modal-under-maximized .oled-modal.oled-modal-16 {
  max-width: 100% !important;
}
.oled-modal-parent .oled-modal-under-maximized .oled-modal.oled-modal-16 div.led-row div.led {
  width: 5px !important;
  height: 5px !important;
  margin: 0 2px 2px 0;
}
.oled-modal-parent .oled-modal-under-maximized .modal-sidebar.start {
  top: 410px;
}
.oled-modal-parent .oled-modal-under-maximized .modal-sidebar.open {
  top: 565px;
}
.oled-modal-parent .oled-modal-under-maximized .oled-modal-close {
  top: -580px;
}

.matrix-modal-parent .matrix-modal {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  border-radius: 1.5%;
  bottom: 0px;
  top: -40px;
  position: absolute;
  left: 0px;
  right: 0px;
  margin: auto;
  padding: 1rem;
  z-index: 2;
  max-width: 20rem;
  max-height: 20rem;
  background-color: #364158;
  background-size: 100px;
  border: 1px solid #252f41;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  justify-content: space-around;
  transition: 0.3s all ease-in-out;
}
.matrix-modal-parent .matrix-modal.rotate-0 {
  transform: rotate(0deg);
  transition: 0.6s all ease-in-out;
}
.matrix-modal-parent .matrix-modal.rotate-90 {
  transform: rotate(-90deg);
}
.matrix-modal-parent .matrix-modal.rotate-180 {
  transform: rotate(-180deg);
}
.matrix-modal-parent .matrix-modal.rotate-270 {
  transform: rotate(-270deg);
}
.matrix-modal-parent .matrix-modal div.led-row {
  display: flex;
  justify-content: space-around;
  flex-direction: row-reverse;
  position: relative;
  width: 100%;
  transition: 0.2s all ease-in-out;
}
.matrix-modal-parent .matrix-modal div.led-row::before {
  transition: inherit;
  content: attr(data-content);
  font-size: 0.8rem;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999999;
}
.matrix-modal-parent .matrix-modal div.led-row:first-child div.led::before {
  content: attr(data-content);
  font-size: 0.8rem;
  position: absolute;
  top: -40px;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999999;
}
.matrix-modal-parent .matrix-modal div.led {
  width: 40px;
  height: 40px;
  background: #A7A9AC;
  border-radius: 50%;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  transition: 0.2s all ease-in-out;
}
.matrix-modal-parent .matrix-modal div.led.led-on {
  background-color: #db0a5b;
  box-shadow: 0 6px 5px rgba(0, 0, 0, 0.15) !important;
}
.matrix-modal-parent .matrix-modal.matrix-modal-8 div.led-row::before {
  top: 5px;
  left: -8px !important;
  height: initial;
  font-size: 0.7rem;
}
.matrix-modal-parent .matrix-modal.matrix-modal-8 div.led-row:first-child div.led::before {
  top: -23px;
  font-size: 0.7rem;
}
.matrix-modal-parent .matrix-modal.matrix-modal-8 div.led-row div.led {
  width: 30px !important;
  height: 30px !important;
}
.matrix-modal-parent .matrix-modal.matrix-modal-8 div.led-row div.led.led-on {
  background-color: #ff3636;
}
.matrix-modal-parent .matrix-modal.matrix-modal-lgo-8 div.led-row::before {
  top: 5px;
  left: -8px !important;
  height: initial;
  font-size: 0.7rem;
}
.matrix-modal-parent .matrix-modal.matrix-modal-lgo-8 div.led-row:first-child div.led::before {
  top: -23px;
  font-size: 0.7rem;
}
.matrix-modal-parent .matrix-modal.matrix-modal-lgo-8 div.led-row div.led {
  width: 20px !important;
  height: 20px !important;
}
.matrix-modal-parent .matrix-modal.matrix-modal-lgo-8 div.led-row div.led.led-on {
  background-color: #3090ef;
}
.matrix-modal-parent .matrix-modal.matrix-modal-16 {
  max-width: 40rem !important;
}
.matrix-modal-parent .matrix-modal.matrix-modal-16 div.led-row::before {
  top: 5px;
  left: -8px !important;
  height: initial;
  font-size: 0.7rem;
}
.matrix-modal-parent .matrix-modal.matrix-modal-16 div.led-row:first-child div.led::before {
  top: -23px;
  font-size: 0.7rem;
}
.matrix-modal-parent .matrix-modal.matrix-modal-16 div.led-row div.led {
  width: 30px !important;
  height: 20px !important;
  border-radius: 15% !important;
}
.matrix-modal-parent .matrix-modal.matrix-modal-16 div.led-row div.led.led-on {
  background-color: #0f6efb;
}
.matrix-modal-parent .icon-modal-16 {
  width: 365px !important;
  height: 160px;
  left: 0;
  right: 0px;
}
.matrix-modal-parent .modal-sidebar {
  width: 280px;
  height: 160px;
  color: white;
  bottom: 0px;
  top: 10px;
  position: absolute;
  left: 0;
  right: 0px;
  margin: auto;
  z-index: 1;
  text-align: center;
  font-size: 1rem;
  transition-delay: 0.2s;
  transition: 0.3s all ease-in-out;
}
.matrix-modal-parent .modal-sidebar.start {
  top: 250px;
}
.matrix-modal-parent .modal-sidebar.start .modal-sidebar-buttons {
  opacity: 1 !important;
}
.matrix-modal-parent .modal-sidebar.open {
  top: 440px;
}
.matrix-modal-parent .modal-sidebar.open .modal-sidebar-main-panel {
  opacity: 1 !important;
}
.matrix-modal-parent .modal-sidebar.transitioning {
  top: 10px;
}
.matrix-modal-parent .modal-sidebar.transitioning .modal-sidebar-main-panel {
  opacity: 0 !important;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel {
  overflow: hidden;
  transition: 0.5s all ease-in-out;
  display: inline-block;
  background: #082847;
  width: 280px;
  height: 90px;
  border-radius: 0.5%;
  padding: 1rem;
  opacity: 0;
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.15) inset;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 5px 10px;
  background-color: #334472;
  border-radius: 50%;
  border: 1px solid rgba(146, 146, 146, 0.027);
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle:hover {
  transform: scale(1.06);
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-white {
  background-color: white;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-red {
  background-color: #cf000f;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-pink {
  background-color: #f62459;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-fuscia {
  background-color: #db0a5b;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-orange {
  background-color: orange;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-copper {
  background-color: #f22613;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-yellow {
  background-color: #f5e51b;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-gold {
  background-color: #f7ca18;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-blue {
  background-color: #2c82c9;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-dark-blue {
  background-color: #4d05e8;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-light-blue {
  background-color: #19b5fe;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-green {
  background-color: #2ecc71;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-dark-green {
  background-color: #1e824c;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.color-circle.bg-teal {
  background-color: teal;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller {
  direction: ltr;
  width: 85%;
  margin: 0 auto;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square {
  display: block;
  width: 50px;
  height: 50px;
  margin: 0 5px;
  background: #f62459;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square:hover {
  filter: brightness(1.4);
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion1 {
  background: url("/images/custom_blocks/matrix8x8/face1.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion2 {
  background: url("/images/custom_blocks/matrix8x8/face2.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion3 {
  background: url("/images/custom_blocks/matrix8x8/face3.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion4 {
  background: url("/images/custom_blocks/matrix8x8/face4.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion5 {
  background: url("/images/custom_blocks/matrix8x8/face5.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion6 {
  background: url("/images/custom_blocks/matrix8x8/face6.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion7 {
  background: url("/images/custom_blocks/matrix8x8/face7.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion8 {
  background: url("/images/custom_blocks/matrix8x8/face8.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion9 {
  background: url("/images/custom_blocks/matrix8x8/face9.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.emotions-square.emotion10 {
  background: url("/images/custom_blocks/matrix8x8/face10.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square {
  display: block;
  width: 50px;
  height: 50px;
  margin: 0 5px;
  background: #f62459;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square:hover {
  filter: brightness(1.4);
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon1 {
  background: url("/images/custom_blocks/matrix8x8/icon1.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon2 {
  background: url("/images/custom_blocks/matrix8x8/icon2.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon3 {
  background: url("/images/custom_blocks/matrix8x8/icon3.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon4 {
  background: url("/images/custom_blocks/matrix8x8/icon4.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon5 {
  background: url("/images/custom_blocks/matrix8x8/icon5.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon6 {
  background: url("/images/custom_blocks/matrix8x8/icon6.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon7 {
  background: url("/images/custom_blocks/matrix8x8/icon7.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon8 {
  background: url("/images/custom_blocks/matrix8x8/icon8.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon9 {
  background: url("/images/custom_blocks/matrix8x8/icon9.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon10 {
  background: url("/images/custom_blocks/matrix8x8/icon10.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon11 {
  background: url("/images/custom_blocks/matrix8x8/icon11.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon12 {
  background: url("/images/custom_blocks/matrix8x8/icon12.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.icon-square.icon13 {
  background: url("/images/custom_blocks/matrix8x8/icon13.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.dice-square {
  margin: 0 auto;
  display: block;
  width: 50px;
  height: 50px;
  background: orange;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.dice-square:hover {
  filter: brightness(1.4);
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.dice-square.dice-1 {
  background: url("/images/custom_blocks/matrix8x8/dice1.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.dice-square.dice-2 {
  background: url("/images/custom_blocks/matrix8x8/dice2.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.dice-square.dice-3 {
  background: url("/images/custom_blocks/matrix8x8/dice3.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.dice-square.dice-4 {
  background: url("/images/custom_blocks/matrix8x8/dice4.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.dice-square.dice-5 {
  background: url("/images/custom_blocks/matrix8x8/dice5.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel .sidebar-scroller span.dice-square.dice-6 {
  background: url("/images/custom_blocks/matrix8x8/dice6.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle {
  display: block;
  width: 100px;
  height: 50px;
  margin: 0 5px;
  background: #0f6efb;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle:hover {
  filter: brightness(1.4);
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion1 {
  background: url("/images/blocks/Bhoot/3.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion2 {
  background: url("/images/blocks/Bhoot/6.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion3 {
  background: url("/images/blocks/Bhoot/8.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion4 {
  background: url("/images/blocks/Bhoot/10.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion5 {
  background: url("/images/blocks/Bhoot/12.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion6 {
  background: url("/images/blocks/Bhoot/15.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion7 {
  background: url("/images/blocks/Bhoot/16.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion8 {
  background: url("/images/blocks/Bhoot/21.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.emotions-rectangle.emotion9 {
  background: url("/images/blocks/Bhoot/24.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle {
  display: block;
  width: 100px;
  height: 50px;
  margin: 0 5px;
  background: #0f6efb;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat !important;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle:hover {
  filter: brightness(1.4);
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon1 {
  background: url("/images/blocks/Bhoot/1.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon2 {
  background: url("/images/blocks/Bhoot/4.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon3 {
  background: url("/images/blocks/Bhoot/5.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon4 {
  background: url("/images/blocks/Bhoot/7.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon5 {
  background: url("/images/blocks/Bhoot/9.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon6 {
  background: url("/images/blocks/Bhoot/12.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon7 {
  background: url("/images/blocks/Bhoot/13.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon8 {
  background: url("/images/blocks/Bhoot/17.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-main-panel span.icon-rectangle.icon9 {
  background: url("/images/blocks/Bhoot/18.png");
  background-size: contain;
  background-position: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons {
  opacity: 0;
  display: flex;
  height: auto;
  margin-top: 0.8rem;
  flex-direction: row-reverse;
  width: 100%;
  justify-content: center;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  margin-left: 0.4rem;
  margin-right: 0.4rem;
  padding: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  border: 1px solid #ffffff9c;
  width: 1rem;
  height: 1rem;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker:hover, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button:hover {
  transform: scale(1.04);
  border-color: rgba(255, 255, 255, 0.815) !important;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.selected, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.selected {
  transform: scale(1.08);
  border-color: white !important;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.color-picker, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.color-picker {
  background-color: #db0a5b;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.emotions-picker, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.emotions-picker {
  background-image: url("/images/custom_blocks/matrix8x8/face_icon.png");
  background-position: center;
  background-size: 60%;
  background-repeat: no-repeat;
  background-color: #26A7FE;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.dice-picker, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.dice-picker {
  background-image: url("/images/custom_blocks/matrix8x8/dice_icon.png");
  background-position: center;
  background-size: 57%;
  background-repeat: no-repeat;
  background-color: #FF6427;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.icon-picker, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.icon-picker {
  background-image: url("/images/custom_blocks/matrix8x8/icon_icon.png");
  background-position: center;
  background-size: 59%;
  background-repeat: no-repeat;
  background-color: #FEB700;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.picker, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.picker {
  width: 2rem;
  height: 2rem;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.button, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.button {
  font-size: 1rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  border: 0;
  color: #f5f5f5;
  margin-top: 0.2rem;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.button:hover, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.button:hover {
  color: white;
  transform: scale(1.08);
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.button:active, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.button:active {
  color: grey;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.button.ruler-button, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.button.ruler-button {
  font-size: 1rem;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.button.rotate-button, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.button.rotate-button {
  font-size: 1rem;
}
.matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.picker.button.rotate-button:hover, .matrix-modal-parent .modal-sidebar .modal-sidebar-buttons span.button.button.rotate-button:hover {
  animation: 0.8s full-rotation cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation-iteration-count: infinite;
  transform: scale(1.08);
  color: white;
}
.matrix-modal-parent .matrix-modal-close {
  bottom: 0px;
  top: -400px;
  position: absolute;
  left: 0px;
  right: 0px;
}

.piano-mini-modal {
  width: 500px;
  margin-left: 60px;
  margin-top: 8px;
  height: 43px;
  display: flex;
  align-items: center;
}
.piano-mini-modal .pseudoBlocklyEmptyText {
  width: 125px;
}
.piano-mini-modal .pseudoBlocklyEmptyText-ES {
  width: 220px;
}
.piano-mini-modal .pseudoBlocklyEmptyText-EN {
  width: 75px;
}
.piano-mini-modal .pseudoBlocklyEmptyTextND-ES {
  width: 115px;
}
.piano-mini-modal .pseudoBlocklyEmptyTextND-EN {
  width: 70px;
}
.piano-mini-modal .pseudoBlocklyText {
  color: #fff;
  font-family: "Helvetica Neue", "Segoe UI", Helvetica, sans-serif;
  font-size: 12pt;
  font-weight: bold;
  white-space: nowrap;
}
.piano-mini-modal .pseudoBlocklyText:first-child {
  margin-left: 14px;
}
.piano-mini-modal .pseudoBlocklyText:nth-child(3) {
  margin-left: 8px;
}
.piano-mini-modal .pseudoBlocklyText:nth-child(6) {
  margin-left: 14px;
}
.piano-mini-modal .note {
  width: 46px;
  height: 34px;
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 700;
  color: #FF6427;
  margin-left: 0.6rem;
  margin-right: 0.6rem;
  background-color: white;
  position: relative;
  border: 1px solid #b73229;
  cursor: pointer;
  font-family: "Helvetica Neue", "Segoe UI", Helvetica, sans-serif;
}
.piano-mini-modal .note .octave {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  width: 20px;
  height: 20px;
  top: -8px;
  right: -10px;
  border-radius: 50%;
  color: white;
  background-color: black;
}
.piano-mini-modal .duration {
  font-size: 16px;
  width: 90px;
  height: 34px;
  color: #575E75;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  margin-left: 10px;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #b73229;
  cursor: pointer;
  font-family: "Helvetica Neue", "Segoe UI", Helvetica, sans-serif;
}
.piano-mini-modal .pin {
  font-size: 16px;
  color: white;
  font-weight: 600;
  margin-left: 7px;
  text-align: center;
  border: 1px solid #b73229;
  background-color: #f44336;
  height: 34px;
  width: 61px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  position: relative;
  border-radius: 5px;
  cursor: pointer;
}
.piano-mini-modal .mini-piano-keys {
  width: 98px;
  height: 100%;
  background-color: black;
  display: flex;
  margin-left: 6px;
  position: relative;
  cursor: pointer;
}
.piano-mini-modal .mini-piano-keys .key {
  display: flex;
}
.piano-mini-modal .mini-piano-keys .key.selected {
  background-color: #ff5722 !important;
  border-top: 1px solid black;
}
.piano-mini-modal .mini-piano-keys .key.white-key {
  background-color: white;
  width: 14px;
  height: 42px;
  border: 1px solid black;
}
.piano-mini-modal .mini-piano-keys .key.black-key {
  background-color: black;
  padding: 0;
  position: absolute;
  width: 6px;
  height: 24px;
}
.piano-mini-modal .mini-piano-keys .key.black-key.c-sharp {
  left: 11px;
}
.piano-mini-modal .mini-piano-keys .key.black-key.d-sharp {
  left: 25px;
}
.piano-mini-modal .mini-piano-keys .key.black-key.f-sharp {
  left: 53px;
}
.piano-mini-modal .mini-piano-keys .key.black-key.g-sharp {
  left: 67px;
}
.piano-mini-modal .mini-piano-keys .key.black-key.a-sharp {
  left: 81px;
}

.piano-modal-parent .piano-modal-close {
  display: none;
  top: 15rem;
  right: 0;
  left: 0;
}
.piano-modal-parent .piano-modal {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  border-radius: 1.5%;
  bottom: 0px;
  top: -40px;
  position: absolute;
  left: 0px;
  right: 0px;
  margin: auto;
  padding: 0.8rem 0.8rem 0.2rem;
  z-index: 2;
  max-width: 30rem;
  max-height: 20rem;
  background-color: #364158;
  background-size: 100px;
  border: 1px solid #252f41;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  justify-content: space-around;
  transition: 0.3s all ease-in-out;
}
.piano-modal-parent .piano-modal .piano-panel {
  height: 30%;
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen {
  width: 34px;
  height: 55px;
  margin-top: 1rem;
  margin-left: 7px;
  position: relative;
  background-color: black;
  border-radius: 5px;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment-octave, .piano-modal-parent .piano-modal .piano-panel .octave-screen::before {
  content: "";
  text-transform: uppercase;
  position: absolute;
  top: -18px;
  left: -4px;
  color: #d6d6d6;
  opacity: 0.7;
  font-weight: 600;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment {
  height: 1.2rem;
  width: 0.2rem;
  background-color: #e6962d;
  border-radius: 25%;
  box-shadow: 0px 0px 6px #e6962d;
  transition: 0.2s all ease-in-out;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment.turned-off {
  opacity: 0.2;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment-A {
  position: absolute;
  top: -3px;
  left: 16px;
  transform: rotate(90deg);
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment-B {
  position: absolute;
  top: 8px;
  left: 26px;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment-C {
  position: absolute;
  top: 29px;
  left: 26px;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment-D {
  position: absolute;
  top: 19px;
  left: 16px;
  transform: rotate(90deg);
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment-E {
  position: absolute;
  top: 29px;
  left: 6px;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment-F {
  position: absolute;
  top: 8px;
  left: 6px;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .segment-G {
  position: absolute;
  top: 40px;
  left: 16px;
  transform: rotate(90deg);
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .octave-button {
  position: absolute;
  left: 40px;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .octave-button.octave-up {
  top: 14px;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #202735;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .octave-button.octave-up:active {
  border-bottom-color: rgba(255, 255, 255, 0.8);
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .octave-button.octave-down {
  position: absolute;
  top: 30px;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 12px solid #202735;
}
.piano-modal-parent .piano-modal .piano-panel .octave-screen .octave-button.octave-down:active {
  border-top-color: white;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen {
  width: 150px;
  height: 55px;
  margin-top: 1rem;
  margin-left: 50px;
  position: relative;
  background-color: black;
  border-radius: 5px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen input.direct-input {
  position: absolute;
  direction: ltr;
  width: 100%;
  height: 100%;
  left: 0px;
  border-radius: 5px;
  background-color: black;
  color: #e6962d;
  text-align: center;
  border: 0;
  z-index: 999;
  opacity: 0;
  transition: 0.2s all ease-in-out;
  font-size: 3rem;
  font-weight: 200;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen input[type=tel]::-webkit-inner-spin-button,
.piano-modal-parent .piano-modal .piano-panel .duration-screen input[type=tel]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment-duration, .piano-modal-parent .piano-modal .piano-panel .duration-screen::before {
  content: "";
  text-transform: uppercase;
  position: absolute;
  top: -18px;
  left: 18px;
  color: #d6d6d6;
  opacity: 0.7;
  font-weight: 600;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .first-digit {
  position: relative;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .second-digit {
  position: relative;
  margin-left: 28px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .third-digit {
  position: relative;
  margin-left: 56px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .fourth-digit {
  position: relative;
  margin-left: 84px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .fifth-digit {
  position: relative;
  margin-left: 112px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment {
  height: 1.2rem;
  width: 0.2rem;
  background-color: #e6962d;
  border-radius: 25%;
  box-shadow: 0px 0px 6px #e6962d;
  transition: 0.2s all ease-in-out;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment.turned-off {
  opacity: 0.2;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment-A {
  position: absolute;
  top: -3px;
  left: 16px;
  transform: rotate(90deg);
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment-B {
  position: absolute;
  top: 8px;
  left: 26px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment-C {
  position: absolute;
  top: 29px;
  left: 26px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment-D {
  position: absolute;
  top: 19px;
  left: 16px;
  transform: rotate(90deg);
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment-E {
  position: absolute;
  top: 29px;
  left: 6px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment-F {
  position: absolute;
  top: 8px;
  left: 6px;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .segment-G {
  position: absolute;
  top: 40px;
  left: 16px;
  transform: rotate(90deg);
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .duration-button {
  position: absolute;
  left: 155px;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .duration-button.duration-up {
  top: 14px;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #202735;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .duration-button.duration-up:active {
  border-bottom-color: rgba(255, 255, 255, 0.8);
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .duration-button.duration-down {
  position: absolute;
  top: 30px;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 12px solid #202735;
}
.piano-modal-parent .piano-modal .piano-panel .duration-screen .duration-button.duration-down:active {
  border-top-color: white;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector {
  position: relative;
  padding-top: 1rem;
  margin-top: 0.1rem;
  margin-left: 50px;
  height: 75px;
  overflow: scroll;
  -ms-overflow-style: none;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector::-webkit-scrollbar {
  display: none;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector::before {
  content: "PIN";
  position: absolute;
  top: 0px;
  left: 72px;
  color: #d6d6d6;
  opacity: 0.7;
  font-weight: 600;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector .upper {
  display: flex;
  flex-direction: row-reverse;
  position: relative;
  min-width: 160px;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector .upper::before {
  content: "";
  position: absolute;
  width: 38%;
  height: 4px;
  border-top: 1px solid #d6d6d6;
  border-left: 1px solid #d6d6d6;
  opacity: 0.4;
  top: -11px;
  left: 4px;
  font-weight: 600;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector .upper::after {
  content: "";
  position: absolute;
  width: 38%;
  height: 4px;
  border-top: 1px solid #d6d6d6;
  border-right: 1px solid #d6d6d6;
  opacity: 0.4;
  top: -11px;
  right: 4px;
  font-weight: 600;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector .lower {
  display: flex;
  flex-direction: row-reverse;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector .pin {
  width: 23px;
  height: 23px;
  background-color: black;
  color: white;
  margin: 2px;
  border-radius: 3px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector .pin.disabled {
  background-color: #252f41 !important;
}
.piano-modal-parent .piano-modal .piano-panel .pin-selector .pin.selected, .piano-modal-parent .piano-modal .piano-panel .pin-selector .pin:hover {
  background-color: #e6962d;
  box-shadow: 0px 0px 6px #e6962d;
}
.piano-modal-parent .piano-modal .piano-panel::after {
  top: 0px;
  right: 0;
  position: absolute;
  height: 2rem;
  width: 8rem;
  margin: 70px 1rem 0;
  background-image: url(/images/logo.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  opacity: 0.1;
}
.piano-modal-parent .piano-modal .piano-keys {
  width: 100%;
  height: 70%;
  display: flex;
  flex-direction: row-reverse;
  position: relative;
}
.piano-modal-parent .piano-modal .piano-keys .selected {
  background-color: #ff5722 !important;
}
.piano-modal-parent .piano-modal .piano-keys .selected span, .piano-modal-parent .piano-modal .piano-keys .selected::after {
  color: white !important;
}
.piano-modal-parent .piano-modal .piano-keys .key {
  transition: 0.2s ease-in-out all;
  cursor: pointer;
}
.piano-modal-parent .piano-modal .piano-keys .white-key {
  width: 20%;
  border: 1px solid #364158;
  height: 98%;
  background-color: #f5f5f5;
  border-radius: 0 0 3px 3px;
}
.piano-modal-parent .piano-modal .piano-keys .white-key span {
  position: absolute;
  bottom: 10px;
  left: 0;
  text-align: center;
  width: 64px;
  color: #bdbdbd;
  font-size: 16px;
}
.piano-modal-parent .piano-modal .piano-keys .white-key.c-natural span {
  left: 0px;
}
.piano-modal-parent .piano-modal .piano-keys .white-key.d-natural span {
  left: 67px;
}
.piano-modal-parent .piano-modal .piano-keys .white-key.e-natural span {
  left: 131px;
}
.piano-modal-parent .piano-modal .piano-keys .white-key.f-natural span {
  left: 197px;
}
.piano-modal-parent .piano-modal .piano-keys .white-key.g-natural span {
  left: 255px;
}
.piano-modal-parent .piano-modal .piano-keys .white-key.a-natural span {
  left: 325px;
}
.piano-modal-parent .piano-modal .piano-keys .white-key.b-natural span {
  left: 392px;
}
.piano-modal-parent .piano-modal .piano-keys .black-key {
  width: 6%;
  height: 50%;
  position: absolute;
  background: black;
  color: black;
  border-radius: 0 0 3px 3px;
}
.piano-modal-parent .piano-modal .piano-keys .black-key.selected span, .piano-modal-parent .piano-modal .piano-keys .black-key.selected::after {
  color: #ff5722 !important;
}
.piano-modal-parent .piano-modal .piano-keys .black-key.c-sharp {
  left: 52px;
}
.piano-modal-parent .piano-modal .piano-keys .black-key.d-sharp {
  left: 117px;
}
.piano-modal-parent .piano-modal .piano-keys .black-key.f-sharp {
  left: 245px;
}
.piano-modal-parent .piano-modal .piano-keys .black-key.g-sharp {
  left: 310px;
}
.piano-modal-parent .piano-modal .piano-keys .black-key.a-sharp {
  left: 375px;
}

.sevenSegments-mini-modal {
  width: 90px;
  height: 105px;
  background-color: transparent;
  border: 0px solid #252f41;
  border-radius: 5%;
  margin-top: 35px;
  margin-left: 40px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.sevenSegments-mini-modal .container {
  background-color: black;
  border-radius: 10px;
  width: 65px;
  height: 90px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.popup-modal-parent .sevenSegments-modal .container .row-horizontal,
.sevenSegments-mini-modal .container .row-horizontal {
  display: flex;
  flex-direction: row;
  margin: 0.07em 0;
  height: 13%;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-left,
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-right,
.sevenSegments-mini-modal .container .row-horizontal .col-left,
.sevenSegments-mini-modal .container .row-horizontal .col-right {
  width: 19%;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center,
.sevenSegments-mini-modal .container .row-horizontal .col-center {
  width: 62%;
  background-color: #383838;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center.led-on,
.sevenSegments-mini-modal .container .row-horizontal .col-center.led-on {
  background-color: #ff3636 !important;
  box-shadow: 0px 0px 10px #ff3636;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center.led-on:before,
.sevenSegments-mini-modal .container .row-horizontal .col-center.led-on:before {
  border-right-color: #ff3636 !important;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center.led-on:after,
.sevenSegments-mini-modal .container .row-horizontal .col-center.led-on:after {
  border-left-color: #ff3636 !important;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center:after,
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center:before,
.sevenSegments-mini-modal .container .row-horizontal .col-center:after,
.sevenSegments-mini-modal .container .row-horizontal .col-center:before {
  content: " ";
  position: relative;
  display: block;
  width: 4px;
  z-index: 1;
  border-top-width: 4px;
  border-top-style: solid;
  border-top-color: transparent;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  border-bottom-color: transparent;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center:before,
.sevenSegments-mini-modal .container .row-horizontal .col-center:before {
  left: -4px;
  border-right-width: 4px;
  border-right-style: solid;
  border-right-color: #383838;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center:after,
.sevenSegments-mini-modal .container .row-horizontal .col-center:after {
  right: -4px;
  border-left-width: 4px;
  border-left-style: solid;
  border-left-color: #383838;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical,
.sevenSegments-mini-modal .container .row-vertical {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 37%;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right,
.sevenSegments-mini-modal .container .row-vertical .col-left,
.sevenSegments-mini-modal .container .row-vertical .col-right {
  width: 16%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  background-color: #383838;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left.led-on,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right.led-on,
.sevenSegments-mini-modal .container .row-vertical .col-left.led-on,
.sevenSegments-mini-modal .container .row-vertical .col-right.led-on {
  background-color: #ff3636 !important;
  box-shadow: 0px 0px 10px #ff3636;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left.led-on:before,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right.led-on:before,
.sevenSegments-mini-modal .container .row-vertical .col-left.led-on:before,
.sevenSegments-mini-modal .container .row-vertical .col-right.led-on:before {
  border-bottom-color: #ff3636 !important;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left.led-on:after,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right.led-on:after,
.sevenSegments-mini-modal .container .row-vertical .col-left.led-on:after,
.sevenSegments-mini-modal .container .row-vertical .col-right.led-on:after {
  border-top-color: #ff3636 !important;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-center,
.sevenSegments-mini-modal .container .row-vertical .col-center {
  width: 68%;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left:after,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left:before,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right:after,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right:before,
.sevenSegments-mini-modal .container .row-vertical .col-left:after,
.sevenSegments-mini-modal .container .row-vertical .col-left:before,
.sevenSegments-mini-modal .container .row-vertical .col-right:after,
.sevenSegments-mini-modal .container .row-vertical .col-right:before {
  content: " ";
  position: relative;
  display: block;
  width: 4px;
  z-index: 1;
  border-left-width: 4px;
  border-left-style: solid;
  border-left-color: transparent;
  border-right-width: 4px;
  border-right-style: solid;
  border-right-color: transparent;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left:before,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right:before,
.sevenSegments-mini-modal .container .row-vertical .col-left:before,
.sevenSegments-mini-modal .container .row-vertical .col-right:before {
  top: -4px;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  border-bottom-color: #383838;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left:after,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right:after,
.sevenSegments-mini-modal .container .row-vertical .col-left:after,
.sevenSegments-mini-modal .container .row-vertical .col-right:after {
  bottom: calc(-100% + 4px);
  border-top-width: 4px;
  border-top-style: solid;
  border-top-color: #383838;
}

.popup-modal-parent .sevenSegments-modal .container {
  padding: 20px 40px;
  text-align: center;
  line-height: 0px;
  color: white;
  font-size: 1.5em;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal {
  cursor: pointer;
  margin: 0.5em 0;
  flex-direction: row-reverse;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center {
  flex-direction: row-reverse;
  line-height: 25px;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center:after,
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center:before {
  width: 14px;
  border-top-width: 14px;
  border-bottom-width: 14px;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center:before {
  left: -14px;
  border-right-width: 14px;
}
.popup-modal-parent .sevenSegments-modal .container .row-horizontal .col-center:after {
  right: -14px;
  border-left-width: 14px;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical {
  cursor: pointer;
  flex-direction: row-reverse;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right {
  padding: 22px 0;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left:after,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left:before,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right:after,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right:before {
  width: 14px;
  border-left-width: 14px;
  border-right-width: 14px;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left:before,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right:before {
  top: -36px;
  border-bottom-width: 14px;
}
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-left:after,
.popup-modal-parent .sevenSegments-modal .container .row-vertical .col-right:after {
  bottom: calc(-100% - 8px);
  border-top-width: 14px;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit,
.popup-modal-parent .sevenSegments-modal .pin-selector {
  position: relative;
  padding-top: 1rem;
  margin-top: 0.1rem;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit::before,
.popup-modal-parent .sevenSegments-modal .pin-selector::before {
  content: "PIN SEGMENTO";
  position: absolute;
  top: 0px;
  left: 93px;
  color: #d6d6d6;
  opacity: 0.7;
  font-weight: 600;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper {
  display: flex;
  flex-direction: row-reverse;
  position: relative;
  min-width: 160px;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper label,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper label {
  text-align: center;
  color: #a1a1a1;
  font-size: 1em;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper label input,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper label input {
  direction: ltr;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper label input:hover,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper label input:hover {
  background-color: black !important;
  box-shadow: none !important;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper label .digit-enable,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper label .digit-enable {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-right: 10px;
  margin-top: 2px;
  background-color: black;
  border-radius: 3px;
  padding-right: 5px;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper label .digit-enable.selected,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper label .digit-enable.selected {
  background-color: #e6962d;
  box-shadow: 0px 0px 6px #e6962d;
  color: white;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper label .digit-enable.selected input,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper label .digit-enable.selected input {
  background-color: #e6962d;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper label .digit-enable .digit-button,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper label .digit-enable .digit-button {
  margin-left: 5px;
  font-size: 1.4em;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper::before,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper::before {
  content: "";
  position: absolute;
  width: 30%;
  height: 4px;
  border-top: 1px solid #d6d6d6;
  border-left: 1px solid #d6d6d6;
  opacity: 0.4;
  top: -11px;
  left: 4px;
  font-weight: 600;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .upper::after,
.popup-modal-parent .sevenSegments-modal .pin-selector .upper::after {
  content: "";
  position: absolute;
  width: 30%;
  height: 4px;
  border-top: 1px solid #d6d6d6;
  border-right: 1px solid #d6d6d6;
  opacity: 0.4;
  top: -11px;
  right: 4px;
  font-weight: 600;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .lower,
.popup-modal-parent .sevenSegments-modal .pin-selector .lower {
  display: flex;
  flex-direction: row-reverse;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .pin,
.popup-modal-parent .sevenSegments-modal .pin-selector .pin {
  width: 23px;
  height: 23px;
  background-color: black;
  color: white;
  margin: 2px;
  border: none;
  border-radius: 3px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
  text-align: center;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .pin.disabled,
.popup-modal-parent .sevenSegments-modal .pin-selector .pin.disabled {
  background-color: #252f41 !important;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit .pin.selected, .popup-modal-parent .sevenSegments-modal .pin-selector-digit .pin:hover,
.popup-modal-parent .sevenSegments-modal .pin-selector .pin.selected,
.popup-modal-parent .sevenSegments-modal .pin-selector .pin:hover {
  background-color: #e6962d;
  box-shadow: 0px 0px 6px #e6962d;
}
.popup-modal-parent .sevenSegments-modal .pin-selector-digit::before {
  content: "PIN DÍGITO";
  left: 104px;
}

.sevenSegments-modal-parent .sevenSegments-modal {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 1.5%;
  bottom: 0px;
  top: -10px;
  position: absolute;
  left: 0px;
  right: 0px;
  margin: auto;
  padding: 0.5rem 0.9rem;
  z-index: 2;
  max-width: 18rem;
  max-height: 30rem;
  background-color: #364158;
  background-size: 100px;
  border: 1px solid #252f41;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  transition: 0.3s all ease-in-out;
}
.sevenSegments-modal-parent .container {
  background-color: black;
  border-radius: 10px;
  width: 16rem;
  height: 20rem;
  padding: 15px 25px;
  display: flex;
  flex-direction: column;
}
.sevenSegments-modal-parent .sevenSegments-modal-close {
  bottom: 0px;
  top: -33rem;
  position: absolute;
  left: 0px;
  right: 0px;
}

@keyframes rotate-and-translate {
  0% {
    transform: translateY(100px) rotate(270deg);
    opacity: 0;
  }
  100% {
    transform: translateY(0) rotate(0);
    opacity: 1;
  }
}
@keyframes full-rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
@keyframes scale-up-center {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scale-up-lower-right {
  0% {
    transform: scale(0) translateX(1000px) translateY(1000px);
  }
  100% {
    transform: scale(1) translateX(0) translateY(0);
  }
}
@keyframes scale-up-upper-right {
  0% {
    transform: scale(0) translateX(1000px) translateY(-1000px);
  }
  100% {
    transform: scale(1) translateX(0) translateY(0);
  }
}
@keyframes scale-up-lower-left {
  0% {
    transform: scale(0) translateX(-1000px) translateY(1000px);
  }
  100% {
    transform: scale(1) translateX(0) translateY(0);
  }
}
@keyframes scale-up-upper-left {
  0% {
    transform: scale(0) translateX(-1000px) translateY(-1000px);
  }
  100% {
    transform: scale(1) translateX(0) translateY(0);
  }
}
@keyframes scale-down-center {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
foreignObject.matrix {
  width: 160px;
  height: 180px;
  margin-top: 10px;
  bottom: 0px;
  position: absolute;
  padding-top: 14px;
  padding-left: 33px;
}
foreignObject.matrix .matrix-modal {
  transform: scale(0.9);
  width: 100%;
  height: 60px;
  overflow: hidden;
  margin-top: 32px;
  margin-left: 1px;
}

foreignObject.matrix-horizontal {
  width: 184px;
  height: 220px;
  margin-top: 10px;
  bottom: 0px;
  position: absolute;
  padding-top: 10px;
}
foreignObject.matrix-horizontal .matrix-modal {
  transform: scale(0.9);
  width: 100%;
  height: 60px;
  overflow: hidden;
  margin-top: 32px;
  margin-left: 1px;
}

foreignObject.oled {
  width: 184px;
  height: 220px;
  margin-top: 10px;
  bottom: 0px;
  position: absolute;
  padding-top: 10px;
}
foreignObject.oled .matrix-modal {
  transform: scale(0.9);
  width: 100%;
  height: 60px;
  overflow: hidden;
  margin-top: 32px;
  margin-left: 1px;
}

foreignObject.matrix-horizontal-junior {
  width: 70px;
  height: 60px;
  margin-top: 10px;
  bottom: 0px;
  position: absolute;
  padding-top: 10px;
  pointer-events: none;
}
foreignObject.matrix-horizontal-junior .matrix-modal {
  transform: scale(0.9);
  width: 100%;
  height: 60px;
  overflow: hidden;
  margin-top: 32px;
  margin-left: 1px;
}

foreignObject.piano {
  position: absolute;
  height: 60px;
  width: 650px;
}

foreignObject.sevenSegments {
  position: absolute;
  height: 135px;
  width: 140px;
}

.slick-slider {
  height: 100%;
}
.slick-slider .slick-list {
  height: 100% !important;
}
.slick-slider .slick-list .slick-track {
  display: flex;
  height: 100%;
}
.slick-slider .slick-list .slick-track .slick-slide {
  display: flex;
  align-items: center;
}
.slick-slider .slick-arrow::before {
  color: #f7f7f7;
}

@keyframes shownOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.create-variable-modal-parent {
  opacity: 0;
  animation: shownOpacity 0.3s ease forwards;
}
.create-variable-modal-parent .middle-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0px;
  top: 0;
  left: 0px;
  right: 7px;
  margin: auto;
  z-index: 2;
  width: 48rem;
  height: 6rem;
  transition: 0.3s all ease-in-out;
  justify-content: center;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  animation: fadeinenlarge 0.2s ease-in-out;
}
.create-variable-modal-parent .middle-container input {
  width: 180px;
}
.create-variable-modal-parent .middle-container .white-back {
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 100%;
  position: relative;
  transition: 0.3s all ease-in-out;
}
.create-variable-modal-parent .middle-container .input-custom {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.create-variable-modal-parent .middle-container .new-selector .box-content {
  position: relative;
  top: 26px;
}
.create-variable-modal-parent .middle-container .new-selector .box {
  user-select: none;
  display: inline-block;
  width: 32%;
  padding: 5px 3px;
  margin: 0px;
  background: blue;
  color: white;
  cursor: pointer;
  font-weight: bold;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}
.create-variable-modal-parent .middle-container .new-selector .box.active {
  opacity: 1;
}
.create-variable-modal-parent .middle-container .new-selector select {
  position: relative;
  top: 35px;
  border: 1px solid #4f36d6;
  text-align: center;
  background: white;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: #a09ea8;
  cursor: pointer;
  margin: auto;
  font-weight: 600;
  padding: 1px 5px;
}
.create-variable-modal-parent .middle-container .new-selector label {
  text-align: center;
  margin: auto;
  position: absolute;
  top: 12px;
  color: #4f36d6;
  font-weight: 600;
  marign: 0px 5px;
}
.create-variable-modal-parent .middle-container .new-buttons {
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: #4f36d6;
  height: 100%;
  font-weight: 600;
}
.create-variable-modal-parent .middle-container .new-buttons div {
  width: 6rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s all ease-in-out;
}
.create-variable-modal-parent .middle-container .new-buttons div:hover {
  background-color: #4f36d6;
  cursor: pointer;
  color: white;
}
.create-variable-modal-parent .middle-container .new-buttons div.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.create-variable-modal-parent .middle-container .new-buttons.new-attr-selector label {
  position: absolute;
  top: 65px;
}
.create-variable-modal-parent .middle-container .new-buttons.new-attr-selector div {
  border-radius: 100%;
  background: #4f36d6;
  color: white;
  width: 22px;
  height: 22px;
}
.create-variable-modal-parent .middle-container .new-buttons.new-attr-selector div.number {
  background: white !important;
  color: #4f36d6 !important;
  width: 30px;
  height: 30px;
}
.create-variable-modal-parent .middle-container .new-buttons.new-attr-selector div:hover {
  color: #4f36d6;
  background: #4531b3;
}
.create-variable-modal-parent .middle-container input {
  background-color: white;
  border: 0;
  border-bottom: 1px solid #4f36d6;
  color: #4f36d6;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
}

.white-back {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 0px 3px grey;
}

.middle-container {
  margin: auto;
  position: absolute;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
}

#dynamic-content {
  display: block;
  width: 100%;
  overflow: hidden;
}
#dynamic-content div.d-block {
  position: relative;
  float: left;
  width: 33%;
  padding: 20px 10px;
}
#dynamic-content input {
  float: left;
  width: calc(100% - 60px);
}
#dynamic-content .select-type-dynamic {
  float: left;
}
#dynamic-content .select-type-dynamic .content-to-show {
  display: none;
  opacity: 0;
  position: absolute;
  left: 0px;
  top: 10px;
  width: 105%;
}
#dynamic-content .select-type-dynamic.active .content-to-show {
  display: block;
  animation: shownOpacity 0.3s ease forwards;
}

.create-function .white-back {
  padding: 0px 12px;
}
.create-function .desist-new, .create-function .create-new {
  max-height: 66px !important;
}
.create-function .new-buttons {
  width: 170px;
}
.create-function .middle-container {
  height: 290px !important;
}
.create-function .new-selector {
  text-align: center;
  width: 190px;
}
.create-function .box-content {
  top: 48px !important;
}
.create-function .new-buttons.new-attr-selector label {
  font-size: 12px;
  top: 40px !important;
}
.create-function.without-variables .middle-container {
  height: 145px !important;
}
.create-function.without-variables #dynamic-content {
  height: 0px;
}
.create-function .select-type-dynamic {
  user-select: none;
  display: inline-block;
  width: 60px;
  padding: 5px 3px;
  margin: 0px;
  background: blue;
  color: white;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  margin-top: 2px;
}
.create-function .dynamic-select-box {
  user-select: none;
  display: inline-block;
  width: 32%;
  padding: 5px 3px;
  margin: 0px;
  background: blue;
  color: white;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  opacity: 0.9;
  transition: opacity 0.2s ease;
}
.create-function .dynamic-select-box:hover {
  opacity: 1;
}

/*# sourceMappingURL=popups.css.map */
`, "",{"version":3,"sources":["webpack://./src/helpers/popups/popups.css","webpack://./src/helpers/popups/popups.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgBhB;EACE,yBAAA;EACA,YAAA;ADdF;;ACiBA;EACE,wBAAA;ADdF;;ACgBA;EACE,qBAAA;ADbF;;ACgBA;EACE,cAAA;ADbF;;ACeA;EACE,gBAAA;ADZF;;ACeA;EACE,gBAAA;EACA,8BAAA;ADZF;ACcE;EACE,qBAAA;EACA,YAAA;EACA,aAAA;ADZJ;ACeE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,6EAAA;EACA,qBAAA;EACA,yBAAA;ADbJ;ACeI;EACE,qBAAA;ADbN;ACiBE;EACE,wEAAA;ADfJ;ACkBE;EACE,0EAAA;ADhBJ;;ACoBA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;ADjBF;ACmBE;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,8DAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,qBAAA;ADjBJ;ACmBI;EACE,8CAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;ADjBN;ACmBM;EACE,WAAA;EACA,6BAAA;EACA,mBAAA;ADjBR;ACmBQ;EACE,UAAA;EACA,WAAA;ADjBV;ACmBU;EACE,oCAAA;ADjBZ;AC2BE;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,8DAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,qBAAA;ADzBJ;AC2BI;EACE,8CAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;ADzBN;AC2BM;EACE,WAAA;EACA,6BAAA;EACA,mBAAA;ADzBR;AC2BQ;EACE,UAAA;EACA,WAAA;ADzBV;AC4BU;EACE,oCAAA;AD1BZ;ACoCE;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;ADlCJ;ACqCE;EAIE,gCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAxLK;EAyLL,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACC,iBAAA;ADtCL;ACwBI;EACE,yBAvLE;ADiKR;;AC0CA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;ADvCF;ACyCE;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,oDAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;ADvCJ;ACyCI;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;ADvCN;ACyCM;EACE,YAAA;EACA,6BAAA;EACA,mBAAA;ADvCR;ACyCQ;EACE,UAAA;EACA,WAAA;ADvCV;ACyCU;EACE,oCAAA;ADvCZ;ACiDE;EACE,UAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AD/CJ;ACiDI;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;AD/CN;ACiDM;EACE,WAAA;EACA,6BAAA;EACA,mBAAA;AD/CR;ACiDQ;EACE,UAAA;EACA,WAAA;EAGA,yBAzRC;ADwOX;ACmDU;EACE,oCAAA;ADjDZ;AC4DE;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AD1DJ;AC6DE;EACE,gCAAA;EACA,UAAA;EACA,WAAA;EACA,mBAjTK;EAkTL,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AD3DJ;AC4DI;EACE,yBA/TE;ADqQR;;ACiEA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AD9DF;ACgEE;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,4DAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;AD9DJ;ACgEI;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;AD9DN;ACgEM;EACE,YAAA;EACA,6BAAA;EACA,mBAAA;AD9DR;ACgEQ;EACE,UAAA;EACA,WAAA;AD9DV;ACgEU;EACE,oCAAA;AD9DZ;ACwEE;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;ADtEJ;ACyEE;EACE,gCAAA;EACA,UAAA;EACA,WAAA;EACA,mBA7XS;EA8XT,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;ADvEJ;ACwEI;EACE,yBAtYM;ADgUZ;ACwEI;EAAa,aAAA;ADrEjB;ACsEI;EAAa,YAAA;ADnEjB;ACoEI;EAAa,aAAA;ADjEjB;ACkEI;EAAc,UAAA;AD/DlB;;ACqEA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;ADlEF;ACoEE;EACE,WAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0CAAA;ADlEJ;ACoEI;EACE,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAjbI;EAkbJ,sBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gCAAA;EAEA,kBAAA;EACA,UAAA;ADnEN;ACqEM;EACE,UAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;ADnER;ACqEQ;EACE,kBAAA;ADnEV;ACsEM;EACE,4EAAA;ADpER;ACsEM;EACE,4EAAA;ADpER;ACuEM;EACE,iFAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;ADrER;ACuEQ;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;ADrEV;AC2EI;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;ADzEN;AC4EI;EACE,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;EACA,sCAAA;EACA,eAAA;AD1EN;AC6EI;EACE,yBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,aAAA;EACA,cAAA;AD5EN;AC8EM;EACE,iCAAA;AD5ER;AC+EM;EACE,2EAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,eAAA;AD7ER;ACgFM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;AD9ER;ACiFM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gFAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;AD/ER;ACkFM;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,8EAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;ADhFR;ACmFM;EACE,aAAA;EACA,6BAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;ADjFR;ACmFQ;EACE,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;ADjFV;ACqFU;EACE,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;ADnFZ;ACuFM;EACE,6BAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAplBK;EAqlBL,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;ADrFR;ACwFQ;EACE,yBAhmBE;AD0gBZ;AC2FM;EACE,2BAAA;ADzFR;AC2FU;EACE,QAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,WAAA;EACA,sBAAA;ADzFZ;AC6FY;EACE,8BAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;AD3Fd;ACgGY;EAAU,yBA/nBV;ADkiBZ;AC8FY;EAAa,aAAA;AD3FzB;AC4FY;EAAa,YAAA;ADzFzB;AC0FY;EAAa,aAAA;ADvFzB;ACwFY;EAAc,UAAA;ADrF1B;AC2FI;EACE,uBAAA;EACA,aAAA;EACA,OAAA;EACA,UAAA;ADzFN;AC8FI;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EAEA,sBAAA;EACA,gCAAA;AD7FN;AC+FM;EACE,UAAA;AD7FR;AC+FQ;EACE,qBAAA;AD7FV;ACiGM;EACE,UAAA;AD/FR;ACiGQ;EACE,qBAAA;AD/FV;ACmGM;EACE,SAAA;ADjGR;ACmGQ;EACE,qBAAA;ADjGV;ACqGM;EACE,gBAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,kDAAA;ADnGR;ACqGQ;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;ADnGV;ACqGU;EACE,sBAAA;ADnGZ;ACsGU;EAAY,uBAAA;ADnGtB;ACoGU;EAAU,yBAAA;ADjGpB;ACkGU;EAAW,yBAAA;AD/FrB;ACgGU;EAAa,yBAAA;AD7FvB;AC8FU;EAAa,wBAAA;AD3FvB;AC4FU;EAAa,yBAAA;ADzFvB;AC0FU;EAAa,yBAAA;ADvFvB;ACwFU;EAAU,yBAAA;ADrFpB;ACsFU;EAAU,yBAAA;ADnFpB;ACoFU;EAAgB,yBAAA;ADjF1B;ACkFU;EAAiB,yBAAA;AD/E3B;ACgFU;EAAY,yBAAA;AD7EtB;AC8EU;EAAiB,yBAAA;AD3E3B;AC4EU;EAAU,sBAAA;ADzEpB;AC4EQ;EACE,cAAA;EACA,UAAA;EACA,cAAA;AD1EV;AC6EQ;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBA3vBE;EA4vBF,wBAAA;EACA,2BAAA;EACA,uCAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;AD3EV;AC6EU;EACE,uBAAA;AD3EZ;AC8EU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AD5EZ;AC8EU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AD5EZ;AC+EQ;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAzxBE;EA0xBF,wBAAA;EACA,2BAAA;EACA,uCAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;AD7EV;AC+EU;EACE,uBAAA;AD7EZ;ACgFU;EACE,+DAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AD9EZ;ACgFU;EACE,iEAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AD9EZ;ACgFU;EACE,iEAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AD9EZ;ACgFU;EACE,kEAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AD9EZ;ACgFU;EACE,8DAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AD9EZ;ACgFU;EACE,iEAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AD9EZ;ACmFM;EACE,UAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;ADjFR;ACmFQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;ADjFV;ACqFU;EACE,sBAAA;EACA,mDAAA;ADnFZ;ACsFU;EACE,sBAAA;EACA,8BAAA;ADpFZ;ACuFU;EACE,yBAn3BJ;AD8xBR;ACuFU;EACE,sEAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;ADrFZ;ACwFU;EACE,sEAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;ADtFZ;AC0FU;EACE,sEAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;ADxFZ;AC4FU;EACE,WAAA;EACA,YAAA;AD1FZ;AC6FU;EACE,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;AD3FZ;AC6FY;EACE,YAAA;EACA,sBAAA;AD3Fd;AC8FY;EACE,WAAA;AD5Fd;AC+FY;EACE,eAAA;AD7Fd;ACmGY;EACE,eAAA;ADjGd;ACkGc;EACE,sEAAA;EACA,mCAAA;EACA,sBAAA;EACA,YAAA;ADhGhB;ACyGI;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;ADvGN;ACwGM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,2BAAA;EACA,eAAA;ADtGR;ACuGQ;EACE,2BAAA;EACA,yBAAA;ADrGV;ACyGM;EACE,8EAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;ADvGR;ACyGM;EACE,8EAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;ADvGR;AC2GI;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;ADzGN;AC2GM;EACE,WAAA;EACA,cAAA;ADzGR;AC4GM;EACE,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;AD1GR;AC6GM;EACE,UAAA;AD3GR;AC8GM;EACE,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AD5GR;AC+GM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AD7GR;ACgHM;EACE,wBAAA;EACA,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;AD9GR;ACiHM;EACE,WAAA;EACA,kBAAA;AD/GR;ACmHI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;ADjHN;ACqHE;EAEE,mBAAA;EACA,kBAAA;EACA,wBAAA;ADpHJ;ACsHI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;ADpHN;ACsHM;EACE,0BAAA;ADpHR;ACsHU;EACE,qBAAA;EACA,sBAAA;EACA,mBAAA;ADpHZ;AC6HM;EAEE,UAAA;AD5HR;AC+HM;EAEE,UAAA;AD9HR;ACkII;EAEE,WAAA;ADjIN;;ACyIE;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBA/mCM;EAgnCN,sBAAA;EACA,yBAAA;EACA,0CAAA;EACA,6BAAA;EACA,gCAAA;ADtIJ;ACwII;EACE,uBAAA;EACA,gCAAA;ADtIN;ACwII;EACE,yBAAA;ADtIN;ACwII;EACE,0BAAA;ADtIN;ACwII;EACE,0BAAA;ADtIN;ACyII;EACE,aAAA;EACA,6BAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;ADvIN;ACyIM;EACE,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;ADvIR;AC2IQ;EACE,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;ADzIV;AC6II;EACE,WAAA;EACA,YAAA;EACA,mBA9qCG;EA+qCH,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACC,iBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gCAAA;AD3IP;AC4IO;EACC,yBA/rCA;EAgsCA,oDAAA;AD1IR;ACgJQ;EACE,QAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AD9IV;ACkJU;EACE,UAAA;EACA,iBAAA;ADhJZ;ACoJQ;EACE,sBAAA;EACA,uBAAA;ADlJV;ACoJU;EAAW,yBAAA;ADjJrB;AC2JQ;EACE,QAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;ADzJV;AC6JU;EACE,UAAA;EACA,iBAAA;AD3JZ;AC+JQ;EACE,sBAAA;EACA,uBAAA;AD7JV;ACgKU;EAAW,yBAAA;AD7JrB;ACsKI;EACE,2BAAA;ADpKN;ACsKQ;EACE,QAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;ADpKV;ACwKU;EACE,UAAA;EACA,iBAAA;ADtKZ;AC0KQ;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;ADxKV;AC0KU;EAAW,yBAnxCT;AD4mCZ;ACgLE;EACE,uBAAA;EACA,aAAA;EACA,OAAA;EACA,UAAA;AD9KJ;ACmLE;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EAEA,sBAAA;EACA,gCAAA;ADlLJ;ACoLI;EACE,UAAA;ADlLN;ACqLM;EACE,qBAAA;ADnLR;ACuLI;EACE,UAAA;ADrLN;ACuLM;EACE,qBAAA;ADrLR;ACyLI;EACE,SAAA;ADvLN;ACyLM;EACE,qBAAA;ADvLR;AC2LI;EACE,gBAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,kDAAA;ADzLN;AC2LM;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;ADzLR;AC2LQ;EACE,sBAAA;ADzLV;AC4LQ;EAAY,uBAAA;ADzLpB;AC0LQ;EAAU,yBAAA;ADvLlB;ACwLQ;EAAW,yBAAA;ADrLnB;ACsLQ;EAAa,yBAAA;ADnLrB;ACoLQ;EAAa,wBAAA;ADjLrB;ACkLQ;EAAa,yBAAA;AD/KrB;ACgLQ;EAAa,yBAAA;AD7KrB;AC8KQ;EAAU,yBAAA;AD3KlB;AC4KQ;EAAU,yBAAA;ADzKlB;AC0KQ;EAAgB,yBAAA;ADvKxB;ACwKQ;EAAiB,yBAAA;ADrKzB;ACsKQ;EAAY,yBAAA;ADnKpB;ACoKQ;EAAiB,yBAAA;ADjKzB;ACkKQ;EAAU,sBAAA;AD/JlB;ACkKM;EACE,cAAA;EACA,UAAA;EACA,cAAA;ADhKR;ACmKQ;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;EACA,uCAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;ADjKV;ACmKU;EACE,uBAAA;ADjKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACoKU;EACE,6DAAA;EACA,wBAAA;EACA,2BAAA;ADlKZ;ACqKQ;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;ADnKV;ACqKU;EACE,uBAAA;ADnKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,6DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,6DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,6DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACsKU;EACE,6DAAA;EACA,wBAAA;EACA,2BAAA;ADpKZ;ACuKQ;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;ADrKV;ACuKU;EACE,uBAAA;ADrKZ;ACwKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADtKZ;ACwKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADtKZ;ACwKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADtKZ;ACwKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADtKZ;ACwKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADtKZ;ACwKU;EACE,4DAAA;EACA,wBAAA;EACA,2BAAA;ADtKZ;AC2KM;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAhlDI;EAilDJ,wBAAA;EACA,2BAAA;EACA,uCAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;ADzKR;AC2KQ;EACE,uBAAA;ADzKV;AC4KQ;EACE,6CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC4KQ;EACE,6CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC4KQ;EACE,6CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC4KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC4KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC4KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC4KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC4KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC4KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD1KV;AC6KM;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBA/oDI;EAgpDJ,wBAAA;EACA,2BAAA;EACA,uCAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;AD3KR;AC6KQ;EACE,uBAAA;AD3KV;AC8KQ;EACE,6CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;AC8KQ;EACE,6CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;AC8KQ;EACE,6CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;AC8KQ;EACE,6CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;AC8KQ;EACE,6CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;AC8KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;AC8KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;AC8KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;AC8KQ;EACE,8CAAA;EACA,wBAAA;EACA,2BAAA;AD5KV;ACiLI;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,uBAAA;AD/KN;ACiLM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AD/KR;ACmLQ;EACE,sBAAA;EACA,mDAAA;ADjLV;ACoLQ;EACE,sBAAA;EACA,8BAAA;ADlLV;ACqLQ;EACE,yBAjvDF;AD8jDR;ACqLQ;EACE,sEAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;ADnLV;ACsLQ;EACE,sEAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;ADpLV;ACwLQ;EACE,sEAAA;EACA,2BAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;ADtLV;AC0LQ;EACE,WAAA;EACA,YAAA;ADxLV;AC2LQ;EACE,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;ADzLV;AC2LU;EACE,YAAA;EACA,sBAAA;ADzLZ;AC4LU;EACE,WAAA;AD1LZ;AC6LU;EACE,eAAA;AD3LZ;ACkMU;EACE,eAAA;ADhMZ;ACiMY;EACE,sEAAA;EACA,mCAAA;EACA,sBAAA;EACA,YAAA;AD/Ld;ACwME;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;ADtMJ;;AC2MA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;ADxMF;AC0ME;EACE,YAAA;ADxMJ;AC0ME;EACE,YAAA;ADxMJ;AC0ME;EACE,WAAA;ADxMJ;AC0ME;EACE,YAAA;ADxMJ;AC0ME;EACE,WAAA;ADxMJ;AC2ME;EACE,WAAA;EACA,gEAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;ADzMJ;AC2MI;EACE,iBAAA;ADzMN;AC4MI;EACE,gBAAA;AD1MN;AC6MI;EACE,iBAAA;AD3MN;AC+ME;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gEAAA;AD7MJ;AC+MI;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;AD7MN;ACiNE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gEAAA;AD/MJ;ACkNE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;ADhNJ;ACoNE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;ADlNJ;ACoNI;EACE,aAAA;ADlNN;ACoNM;EACE,oCAAA;EACA,2BAAA;ADlNR;ACqNM;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;ADnNR;ACqNM;EACE,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;ADnNR;ACqNQ;EACE,UAAA;ADnNV;ACsNQ;EACE,UAAA;ADpNV;ACuNQ;EACE,UAAA;ADrNV;ACwNQ;EACE,UAAA;ADtNV;ACyNQ;EACE,UAAA;ADvNV;;AC+NE;EACE,aAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;AD5NJ;AC8NE;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBA9/DM;EA+/DN,sBAAA;EACA,yBAAA;EACA,0CAAA;EACA,6BAAA;EACA,gCAAA;AD5NJ;AC8NI;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;AD5NN;AC8NM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AD5NR;AC8NQ;EAEE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AD7NV;ACgOQ;EACE,cAAA;EACA,aAAA;EACA,yBAjiEI;EAkiEJ,kBAAA;EACA,+BAAA;EACA,gCAAA;AD9NV;ACgOU;EACE,YAAA;AD9NZ;ACkOQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;ADhOV;ACkOQ;EACE,kBAAA;EACA,QAAA;EACA,UAAA;ADhOV;ACkOQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADhOV;ACkOQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;ADhOV;ACkOQ;EACE,kBAAA;EACA,SAAA;EACA,SAAA;ADhOV;ACmOQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;ADjOV;ACoOQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;ADlOV;ACqOQ;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gCAAA;ADnOV;ACqOU;EACE,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;ADnOZ;ACqOY;EACE,6CAAA;ADnOd;ACuOU;EACE,kBAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;ADrOZ;ACuOY;EACE,uBAAA;ADrOd;AC0OM;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;ADxOR;AC0OQ;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAnoEI;EAooEJ,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;ADxOV;AC4OQ;;EAEE,wBAAA;EACA,SAAA;AD1OV;AC6OQ;EAEE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AD5OV;AC+OQ;EACE,kBAAA;AD7OV;ACgPQ;EACE,kBAAA;EACA,iBAAA;AD9OV;ACiPQ;EACE,kBAAA;EACA,iBAAA;AD/OV;ACkPQ;EACE,kBAAA;EACA,iBAAA;ADhPV;ACmPQ;EACE,kBAAA;EACA,kBAAA;ADjPV;ACoPQ;EACE,cAAA;EACA,aAAA;EACA,yBA3rEI;EA4rEJ,kBAAA;EACA,+BAAA;EACA,gCAAA;ADlPV;ACoPU;EACE,YAAA;ADlPZ;ACsPQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;ADpPV;ACsPQ;EACE,kBAAA;EACA,QAAA;EACA,UAAA;ADpPV;ACsPQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADpPV;ACsPQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;ADpPV;ACsPQ;EACE,kBAAA;EACA,SAAA;EACA,SAAA;ADpPV;ACuPQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;ADrPV;ACwPQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;ADtPV;ACyPQ;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;ADvPV;ACyPU;EACE,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;ADvPZ;ACyPY;EACE,6CAAA;ADvPd;AC2PU;EACE,kBAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;ADzPZ;AC2PY;EACE,uBAAA;ADzPd;AC+PM;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,YAAA;EACA,gBAAA;EACA,wBAAA;AD9PR;AC+PQ;EACE,aAAA;AD7PV;ACiQQ;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AD/PV;ACkQQ;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;ADhQV;ACkQU;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;ADhQZ;ACkQU;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EACA,+BAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;ADhQZ;ACqQQ;EACE,aAAA;EACA,2BAAA;ADnQV;ACsQQ;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;ADpQV;ACsQU;EACE,oCAAA;ADpQZ;ACuQU;EACE,yBA91EE;EA+1EF,+BAAA;ADrQZ;AC6QM;EACE,QAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,YAAA;AD3QR;AC+QI;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,kBAAA;AD7QN;AC+QM;EACE,oCAAA;AD7QR;AC+QQ;EAEE,uBAAA;AD9QV;ACkRM;EACE,gCAAA;EACA,eAAA;ADhRR;ACmRM;EACE,UAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,0BAAA;ADjRR;ACmRQ;EACE,kBAAA;EACA,YAAA;EAEA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;ADlRV;ACqRQ;EACE,SAAA;ADnRV;ACqRQ;EACE,UAAA;ADnRV;ACqRQ;EACE,WAAA;ADnRV;ACqRQ;EACE,WAAA;ADnRV;ACqRQ;EACE,WAAA;ADnRV;ACqRQ;EACE,WAAA;ADnRV;ACqRQ;EACE,WAAA;ADnRV;ACuRM;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,0BAAA;ADrRR;ACwRU;EAEE,yBAAA;ADvRZ;AC2RQ;EACE,UAAA;ADzRV;AC4RQ;EACE,WAAA;AD1RV;AC6RQ;EACE,WAAA;AD3RV;AC8RQ;EACE,WAAA;AD5RV;AC+RQ;EACE,WAAA;AD7RV;;ACwSA;EACE,WAAA;EACA,aAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;ADrSF;ACuSE;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;ADrSJ;;AC4SE;;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;ADxSJ;AC0SI;;;;EAEE,UAAA;ADtSN;ACwSI;;EACE,UAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ADrSN;ACsSM;;EACE,oCAAA;EACA,gCAAA;ADnSR;ACqSM;;EACE,sCAAA;ADlSR;ACoSM;;EACE,qCAAA;ADjSR;ACqSI;;;;EAEE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,6BAAA;EACA,wBAAA;EACA,0BAAA;EACA,gCAAA;ADjSN;ACmSI;;EACE,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;ADhSN;ACkSI;;EACE,WAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;AD/RN;ACmSE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ADhSJ;ACkSI;;;;EAEE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;AD9RN;AC+RM;;;;EACE,oCAAA;EACA,gCAAA;AD1RR;AC4RM;;;;EACE,uCAAA;ADvRR;ACyRM;;;;EACE,oCAAA;ADpRR;ACuRI;;EACE,UAAA;ADpRN;ACuRI;;;;;;;;EAIE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;ADjRN;ACmRI;;;;EAEE,SAAA;EACA,wBAAA;EACA,0BAAA;EACA,4BAAA;AD/QN;ACiRI;;;;EAEE,yBAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;AD7QN;;ACoRE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;ADjRJ;ACmRI;EACE,eAAA;EACA,eAAA;EACA,2BAAA;ADjRN;ACmRM;EACE,2BAAA;EACA,iBAAA;ADjRR;ACmRM;;EAEE,WAAA;EACA,sBAAA;EACA,yBAAA;ADjRR;ACmRM;EACE,WAAA;EACA,wBAAA;ADjRR;ACmRM;EACE,YAAA;EACA,uBAAA;ADjRR;ACqRI;EACE,eAAA;EACA,2BAAA;ADnRN;ACqRM;;EAEE,eAAA;ADnRR;ACqRM;;;;EAIE,WAAA;EACA,uBAAA;EACA,wBAAA;ADnRR;ACqRM;;EAEE,UAAA;EACA,yBAAA;ADnRR;ACqRM;;EAEE,yBAAA;EACA,sBAAA;ADnRR;ACwRE;;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;ADtRJ;AC0RI;;EACE,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;ADvRN;AC0RI;;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;ADvRN;ACyRM;;EACE,kBAAA;EACA,cAAA;EACA,cAAA;ADtRR;ACwRQ;;EAEE,cAAA;ADtRV;ACuRU;;EACE,kCAAA;EACA,2BAAA;ADpRZ;ACwRQ;;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;ADrRV;ACuRU;;EACE,yBA/tFE;EAguFF,+BAAA;EACA,YAAA;ADpRZ;ACqRY;;EACE,yBAnuFA;ADi9Ed;AC8RU;;EACE,gBAAA;EACA,gBAAA;AD3RZ;ACgSM;;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AD7RR;AC+RM;;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EACA,+BAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;AD5RR;ACiSI;;EACE,aAAA;EACA,2BAAA;AD9RN;ACiSI;;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;AD9RN;ACgSM;;EACE,oCAAA;AD7RR;ACgSM;;;EACE,yBA3yFM;EA4yFN,+BAAA;AD5RR;ACmSI;EACE,qBAAA;EACA,WAAA;ADjSN;;ACwSE;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBA90FM;EA+0FN,sBAAA;EACA,yBAAA;EACA,0CAAA;EACA,gCAAA;ADrSJ;ACwSE;EACE,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;ADtSJ;ACySE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;ADvSJ;;AC4SA;EACE;IACE,2CAAA;IACA,UAAA;EDzSF;EC2SA;IACE,kCAAA;IACA,UAAA;EDzSF;AACF;AC2SA;EACE;IACE,uBAAA;EDzSF;EC6SA;IACE,0BAAA;ED3SF;AACF;AC+SA;EACE;IACE,mBAAA;ED7SF;EC+SA;IACE,mBAAA;ED7SF;AACF;AC+SA;EACE;IACE,yDAAA;ED7SF;EC+SA;IACE,+CAAA;ED7SF;AACF;AC+SA;EACE;IACE,0DAAA;ED7SF;EC+SA;IACE,+CAAA;ED7SF;AACF;AC+SA;EACE;IACE,0DAAA;ED7SF;EC+SA;IACE,+CAAA;ED7SF;AACF;AC+SA;EACE;IACE,2DAAA;ED7SF;EC+SA;IACE,+CAAA;ED7SF;AACF;ACiTA;EACE;IACE,mBAAA;ED/SF;ECiTA;IACE,mBAAA;ED/SF;AACF;ACmTA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ADjTF;ACkTE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;ADhTJ;;ACoTA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;ADjTF;ACkTE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;ADhTJ;;ACoTA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;ADjTF;ACkTE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;ADhTJ;;ACqTA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;ADlTF;ACmTE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;ADjTJ;;ACqTA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;ADlTF;;ACqTA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;ADlTF;;ACsTA;EACE,YAAA;ADnTF;ACoTE;EACE,uBAAA;ADlTJ;ACmTI;EACE,aAAA;EACA,YAAA;ADjTN;ACmTM;EACE,aAAA;EACA,mBAAA;ADjTR;ACuTI;EACE,cAAA;ADrTN;;AC0TA;EACE;IAAI,UAAA;EDtTJ;ECuTA;IAAM,UAAA;EDpTN;AACF;ACsTA;EACE,UAAA;EACA,0CAAA;ADpTF;ACsTE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,uBAAA;EACA,0CAAA;EACA,yCAAA;ADpTJ;ACqTI;EAAQ,YAAA;ADlTZ;ACmTI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;ADjTN;ACmTI;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;ADjTN;ACqTM;EACI,kBAAA;EACA,SAAA;ADnTV;ACqTM;EACE,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;ADnTR;ACoTQ;EACE,UAAA;ADlTV;ACuTQ;EACI,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;ADrTZ;ACuTU;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;ADrTZ;ACyTI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;ADvTN;ACwTM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;ADtTR;ACuTQ;EACE,yBAroGC;EAsoGD,eAAA;EACA,YAAA;ADrTV;ACuTQ;EACE,oBAAA;EACA,YAAA;ADrTV;ACyTU;EACE,kBAAA;EACA,SAAA;ADvTZ;ACyTU;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;ADvTZ;ACwTY;EACE,4BAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;ADtTd;ACwTY;EACE,cAAA;EACA,mBAAA;ADtTd;AC4TI;EACE,uBAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AD1TN;;AC+TA;EAAc,WAAA;EAAa,YAAA;EAAc,iBAAA;EAAmB,4BAAA;ADxT5D;;AC0TA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ADvTF;;AC0TA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;ADvTF;ACwTE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;ADtTJ;ACwTE;EACE,WAAA;EACA,wBAAA;ADtTJ;ACwTE;EACE,WAAA;ADtTJ;ACuTI;EACE,aAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;ADrTN;ACyTI;EACE,cAAA;EACA,0CAAA;ADvTN;;AC6TE;EAAc,iBAAA;ADzThB;AC0TE;EACE,2BAAA;ADxTJ;AC0TE;EACE,YAAA;ADxTJ;AC0TE;EACE,wBAAA;ADxTJ;AC0TE;EACE,kBAAA;EACA,YAAA;ADxTJ;AC0TE;EACE,oBAAA;ADxTJ;AC0TE;EACI,eAAA;EACA,oBAAA;ADxTN;AC2TI;EACE,wBAAA;ADzTN;AC2TI;EACE,WAAA;ADzTN;AC4TE;EACE,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AD1TJ;AC6TE;EACE,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;AD3TJ;AC4TI;EAAU,UAAA;ADzTd;;AAEA,qCAAqC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
